import React, { useMemo, useEffect, useCallback, useRef } from 'react';
import CardCenter from 'Components/CardCenter';
import dashboardTabStyles from 'assets/css/DashboardTab.module.css';
import cardCenterStyles from 'assets/css/CardBoard.module.css';
import classNames from 'classnames';
import { allActions, allSelectors, useEventEmitter } from '@ace/react-utilities';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';


export default function TabCenter({content}) {
    /*
    ==== Data needed ====
    CurrentlySelectedTab
    Tab.Styles //for card center layout
    DashboardTab.TabKey
    CardCenter.RetrievalUrl
    CardCenter.Type
    CardCenter.Draggable //for whether cards are draggable
    CardCenter.Toggleable //for whether cards are toggleable
    */

    return (
        <>
            {useMemo(
                () => (<>
                    {
                        content.Tabs.length > 1 ?
                        <div className={dashboardTabStyles.dtHeader}>
                            <div className={dashboardTabStyles.dtHeaderInner}>
                                <nav className={dashboardTabStyles.dtHeaderNav}>
                                    <ul className={dashboardTabStyles.dtHeaderItems}>
                                        {content.Tabs.map(tab => (<TabHeader {...tab}/>))}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        : false
                    }
                    </>
                ),
                [content.Tabs])}
            <TabCenterContent defaultTab={content.Tabs[0]} />
        </>
    )
}
export const TabCenterComponentName = 'DashboardTabCenter';

export const DASHBOARD_TAB_CENTER_EVENTS = {
    ON_TAB_CHANGE: 'dashboardTabChanged'
};

function TabHeader(props) {
    const dispatch = useDispatch();

    const activeDashboardTabKey = useSelector(allSelectors.dashboardTabSelector.makeSelectActiveDashboardTabKey(), shallowEqual);

    const setActiveTab = useCallback(() => {
        dispatch(allActions.dashboardTabActions.setActiveTab(props.TabKey));
    }, [dispatch, props.TabKey]);

    const classes = classNames(dashboardTabStyles.dtHeaderItem, {
        [`${dashboardTabStyles["dtHeaderItem--active"]}`]: activeDashboardTabKey === props.TabKey
    });

    //show dashboard tab on click
    //display title
    return (
        <li className={classes} onClick={() => setActiveTab()}>
            <span className={dashboardTabStyles.dtHeaderItemTitle}>{props.TabDisplay}</span>
        </li>
    )
}

function TabCenterContent(props) {
    const applyEventEmitter = useEventEmitter(TabCenterComponentName);
    const activeDashboardTab = useSelector(allSelectors.dashboardTabSelector.makeSelectActiveDashboardTabContent(), shallowEqual) || props.defaultTab;
    const firstUpdate = useRef(true);

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        } else {
            applyEventEmitter((emitter) => {
                emitter.emit(DASHBOARD_TAB_CENTER_EVENTS.ON_TAB_CHANGE);
            });
        }
    }, [applyEventEmitter, activeDashboardTab.TabKey]);

    const cardCenterClasses = classNames(cardCenterStyles.CardCenterWrapper, {
        [`${cardCenterStyles[activeDashboardTab.TabContentClassName]}`]: activeDashboardTab.TabContentClassName
    });

    return (
        <div className={cardCenterClasses}>
            <CardCenter retrievalUrl={activeDashboardTab.CardCenter.RetrievalUrl} type={activeDashboardTab.CardCenter.Type} componentName={`${activeDashboardTab.TabKey}-${activeDashboardTab.CardCenter.Type}`} />
        </div>
    );
}

// public int TabID { get; set; }
//         public string TabType { get; set; }
//         public string TabKey { get; set; }
//         public string TabDisplay { get; set; }
//         public string TabTitle { get; set; }
//         public string TabShortTitle { get; set; }
//         public int TabOrdinal { get; set; }
//         public string TabContentClassName { get; set; }
